<template>
  <div
    class="ui-space-table__row"
    :style="{
      'grid-template-columns': gridLayout,
      'grid-template-rows': height
    }"
    @click="$emit('click')"
  >
    <template v-if="loading">
      <div
        v-for="(title, idx) in navTitles"
        :key="idx"
        class="ui-space-table__col"
        :class="loadCellClass"
      >
        <div class="ui-space-table__col-container -loading-">
          <div class="ajax__line" :style="{ height: '100%', width: '100%' }" />
        </div>
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    defaultWidth: {
      type: String,
      default: '60px'
    },
    navTitles: {},
    height: {
      type: String,
      default: '32px'
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadCellClass: {}
  },
  computed: {
    gridLayout() {
      const result = [];

      this.navTitles.forEach(prop => {
        if (prop) {
          result.push(prop.width || this.defaultWidth);
        }
      });

      return result.join(' ');
    }
  }
};
</script>
